export function formatBreakoutCountdown(ms: number): string {
  const total = Math.max(0, Math.round(ms / 1000));
  const minutes = Math.floor(total / 60);
  const seconds = total % 60;
  return minutes > 0 ? `${minutes}:${String(seconds).padStart(2, '0')}` : `${seconds}s`;
}

export function breakoutLiveSignatures(
  revision: number,
  endsAt: number | null,
  closingAt: number | null,
  roster: readonly { actorNr: number; breakoutRoomId?: string | null }[],
): { roomsSig: string; controlsSig: string } {
  const occupancy = roster
    .map((user) => `${user.actorNr}:${user.breakoutRoomId || ''}`)
    .sort()
    .join(',');
  return {
    roomsSig: `${revision}|${occupancy}`,
    controlsSig: `${revision}|${endsAt ? 'timer' : 'no-timer'}|${closingAt ? 'closing' : 'open'}`,
  };
}
